import { createContext } from "react";

export const ConfigGeneralContext = createContext();
